export default "<div class=\"footer-custom\">\n    <div class=\"pull-right\">\n        <strong>Version</strong> {{version}}\n    </div>\n</div>\n";